import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {ExhibitType, ExhibitTypeData} from "types/ExhibitType";
import deserializeExhibitType from "services/ngage/deserializers/exhibit-type";

/**
 * Get all exhibit types (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<ExhibitType> | null>(`/exhibit-types?page=${page}`)

    if(response.data){
        response.data.data = response.data.data.map(deserializeExhibitType)
    }

    return response.data
}

/**
 * Get a single exhibit type
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<ExhibitType>(`/exhibit-types/${id}`)
    return response.data? deserializeExhibitType(response.data) : null
}

/**
 * Store a new exhibit type
 *
 * @param data
 */
const store = async (data: ExhibitTypeData) => {
    const response = await client.post<ExhibitType>('/exhibit-types', data)
    return response.data? deserializeExhibitType(response.data) : null
}

/**
 * Update an existing exhibit type
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: ExhibitTypeData) => {
    const response = await client.put<ExhibitType>(`/exhibit-types/${id}`, data)
    return response.data? deserializeExhibitType(response.data) : null
}

/**
 * Permanently delete an exhibit type
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/exhibit-types/${id}`)
    return response.status === 204
}

const exhibitTypes = {
    all,
    get,
    store,
    update,
    destroy
}

export default exhibitTypes;